<script type="text/jsx" lang="jsx">
import { mapGetters } from 'vuex';

import ParticipantsDiffPopover from '@/plans/LARGE_MEETING/component/participants-diff-popover.vue';
import planCommonMixin from '@/plans/LARGE_MEETING/mixin';
import ConfigBase from '@/components/config-base';
import autofill from "@/plans/mx/autofill";
import { getNewPlanUnitWithQuantity } from '@/common/product-unit';

export default {
  name: 'ConfigBase',
  extends: ConfigBase,
  mixins: [planCommonMixin, autofill],
  components: { ParticipantsDiffPopover },
  data() {
    return {
      orderByKey: "capacity",
    };
  },
  props: {
    showPlanDetails: Boolean,
    planDetailsLabel: String,
  },
  methods: {
    mx_renderConfigDesc() {
      if (this.$context.is.modalDelta) return '';
      return <p class="opc-addon-config__main__title">
        <span>{this.configDescription}</span>
        <ParticipantsDiffPopover type={this.planType} />
      </p>;
    },
    mx_renderLicense(plan) {
      const quantity = plan.cartInfo.selected_number;
      if (!quantity) return '';
      const unitDesc = getNewPlanUnitWithQuantity(this.unit, quantity);
      const amount = this.$money(plan.amount + (plan?.esmd_amount || 0));
      return `${unitDesc} x ${amount}`;
    },
    mx_renderTitle() {
      const isShowCheckIcon = this.hasSelectedPlan;

      return <h2 ref='baseCardName' class={`opc-zm-base-card__name text-capitalize ${this.isExpanded ? 'title-pr__without-edit' : 'title-pr__with-edit'}`}>
        {
          this.$context.is.modalDelta ?
            `${this.title} | ${this.currentEditPlan?.capacity} ${this.$t('billing.participants')}` :
            this.title
        }
        {isShowCheckIcon ? <i check-icon class="zm-icon-success main-icon" aria-hidden="true" /> : null}
      </h2>;
    },
  },
  computed: {
    ...mapGetters(['currentEditPlan']),
  }
};
</script>
